import { useEffect } from 'react';

import { withConfig } from 'Context/ConfigContext';

import { useClassroomVideoTracking } from '../useClassroomVideoTracking';

function ClassroomHeartbeatLogger({ appConfig }) {
  const classroomHeartbeatSeconds = appConfig.googleAnalytics?.classroomHeartbeatSeconds ?? 10 * 60;
  const { sendHeartbeat } = useClassroomVideoTracking();
  useEffect(() => {
    const interval = setInterval(() => {
      sendHeartbeat();
    }, classroomHeartbeatSeconds * 1000);
    return () => clearInterval(interval);
  }, [classroomHeartbeatSeconds, sendHeartbeat]);

  return null;
}

export default withConfig(ClassroomHeartbeatLogger);
